import { memo, useCallback } from "react";

import type { MFASettingsType } from "@/hooks/use-auth-client/use-mfa-settings";

import { QuestionForMain } from "@/components/features/_layouts/island/main/question";

import type { FormOptionType } from "@/components/ui/form/_types/type";
import { RadioGroupField } from "@/components/ui/form/fields/radio-field/radio-group";

type Props = {
	mfaSettings: MFASettingsType;
	onSettingsChange: (newSettings: MFASettingsType) => void;
};

const OPTIONS: Array<FormOptionType> = [
	{
		id: "ENABLED",
		label: "有効にする",
		value: "ENABLED",
	},
	{
		id: "DISABLED",
		label: "無効にする",
		value: "DISABLED",
	},
];

export const MfaToggleControls = memo(({ mfaSettings, onSettingsChange }: Props) => {
	const handleMfaStatusChange = useCallback(
		(newStatus: string) => {
			const newSettings: MFASettingsType = {
				...mfaSettings,
				mfaStatus: newStatus as MFASettingsType["mfaStatus"],
			};
			onSettingsChange(newSettings);
		},
		[mfaSettings, onSettingsChange],
	);

	return (
		<QuestionForMain
			title="２段階認証の設定"
			inputChildren={
				<div className="space-y-8">
					<div className="space-y-3">
						<div className="space-y-2 rounded-r-md border-l-4 border-zinc-500 bg-zinc-100 p-3">
							<p>この設定について</p>
							<ul className="text-gray-700 list-inside list-disc space-y-1 text-sm">
								<li>アカウント（ユーザー）ごとの設定となります</li>
								<li>管理している全ての施設で共通の設定となります</li>
								<li>有効にすると、次回ログイン時から２段階認証が実施されます</li>
							</ul>
						</div>
					</div>
					<RadioGroupField
						value={mfaSettings.mfaStatus}
						options={OPTIONS}
						handleValueChange={handleMfaStatusChange}
					/>
				</div>
			}
		/>
	);
});

MfaToggleControls.displayName = "MfaToggleControls";
